<template>
    <div class="themed-search">
        <div class="themed-search__wrapper">
            <theme-icon icon="search" type="icons" classes="themed-search__icon" />
            <input
                :value="value"
                @input="$emit('input', $event.target.value)"
                :placeholder="placeholder"
                :aria-label="ariaLabel || placeholder"
                type="search"
                class="themed-search__input"
            />
            <theme-icon
                v-if="value"
                icon="close-small"
                type="icons"
                classes="themed-search__clear"
                @click.native="clearSearch"
                role="button"
                tabindex="0"
                aria-label="Clear search"
            />
        </div>
    </div>
</template>

<script>
import ThemeIcon from './ThemeIcon.vue';

export default {
    name: 'ThemedSearch',
    
    components: {
        ThemeIcon,
    },

    props: {
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: 'Search...'
        },
        ariaLabel: {
            type: String,
            default: null
        }
    },

    methods: {
        clearSearch() {
            this.$emit('input', '');
            this.$emit('clear');
        }
    }
};
</script>
